import { render, staticRenderFns } from "./multi.vue?vue&type=template&id=06a247aa&scoped=true"
import script from "./multi.vue?vue&type=script&lang=js"
export * from "./multi.vue?vue&type=script&lang=js"
import style0 from "./multi.vue?vue&type=style&index=0&id=06a247aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a247aa",
  null
  
)

export default component.exports